var generic = generic || {};
var site = site || {};

(function ($) {
  // Email signup JS related code
  site.emailSignup = {
    templateContainer: $(),

    initEmailSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var $emailContainerNode = $(this);
        var $emailForm = $emailContainerNode.is('form')
          ? $emailContainerNode
          : $('form', $emailContainerNode);
        var $emailSuccess = $('.email-signup__success', $emailContainerNode);
        var $emailError = $('.email-signup__error', $emailContainerNode);
        var $emailInput = $('input[name="PC_EMAIL_ADDRESS"]', $emailContainerNode);
        var $emailErrorList = $('.js-email-signup__error', $emailContainerNode);
        var $smsErrorNode = $emailContainerNode.find('.js-sms-signup__error');
        var $smsInputNode = $emailContainerNode.find('.js-sms-signup__input');
        var $smsSignupTerms = $emailContainerNode.find('.js-sms-signup__terms');
        var $emailTncError = $emailContainerNode.find('.js-email-tnc-signup__error');
        var $smsTncError = $emailContainerNode.find('.js-sms-tnc-signup__error');
        var colorboxSettings = {
          html: $emailSuccess.html(),
          className: 'confirmation-success-overlay-wrapper',
          width: '325px',
          height: '220px',
          fixed: true,
          maxWidth: '325px',
          maxHeight: '220px'
        };

        function toggleSMSFormElementsVisibility(val) {
          $smsErrorNode.addClass('hidden');
          $smsInputNode.removeClass('error');

          if (val) {
            colorboxSettings.html = $('.js-sms-signup__success', $emailContainerNode).html();
            $smsSignupTerms.show();
          } else {
            $('.js-sms-signup__checkbox', $emailContainerNode).prop('checked', false);
            colorboxSettings.html = $emailSuccess.html();
            $smsSignupTerms.hide();
          }
        }

        $smsInputNode.on('change keyup paste', function () {
          toggleSMSFormElementsVisibility($smsInputNode.val());
        });

        $emailForm.once('email-signup__form').submit(function (submitEvt) {
          submitEvt.preventDefault();
          $emailSuccess.add($emailError).addClass('hidden');
          $emailInput.removeClass('error');
          $emailForm.find('label, input').removeClass('error');
          $smsErrorNode.addClass('hidden').empty();
          $emailErrorList.addClass('hidden').empty();
          $emailTncError.addClass('hidden').empty();
          $smsTncError.addClass('hidden').empty();

          var params = {};

          $.each($emailForm.serializeArray(), function (index, kv) {
            params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
          });

          if ($emailContainerNode.find('.js-sms-signup__checkbox').prop('checked')) {
            params.SMS_PROMOTIONS = 1;
          } else {
            params.SMS_PROMOTIONS = 0;
          }

          var $emailSignupParentElement = $('.js-email-signup', '.content').parent(); // Need to "catch" the higher level element of this section

          // Send the data via a json rpc call
          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [params],
            onSuccess: function (jsonRpcResponse) {
              // 1st condition satisfies in promotions page where as in footer it has three levels so introduced the OR condition
              if (
                $emailSignupParentElement.parent().hasClass('content') ||
                $emailSignupParentElement.hasClass('content')
              ) {
                // Only show the success message if the email_signup.success handlers haven't already done so
                if ($('#colorbox').css('display') !== 'block') {
                  $.colorbox(colorboxSettings);
                }
              } else {
                $.when($(document).triggerHandler('email_signup.success', [jsonRpcResponse])).then(
                  function () {
                    // Only show the success message if the email_signup.success handlers haven't already done so
                    if ($('#colorbox').css('display') !== 'block') {
                      $.colorbox({ html: $emailSuccess.html() });
                    }
                    if (
                      typeof site.track !== 'undefined' &&
                      site.track.emailSignup !== 'undefined' &&
                      typeof site.track.emailSignup === 'function'
                    ) {
                      site.track.emailSignup();
                    }
                  }
                );
              }
              $('.email_signup_sucess_popup .email-signup__success-text').on('click', function () {
                $.colorbox.close();
              });
            },
            onFailure: function (jsonRpcResponse) {
              var error_message = jsonRpcResponse.getMessages();
              var i;
              var myErr;

              $emailError.removeClass('hidden');
              for (i = 0; i < error_message.length; i++) {
                myErr = error_message[i];

                if (myErr.key === 'invalid.pc_email_address.email_signup' || myErr.key === 'required.pc_email_address.email_signup') {
                  $emailInput.addClass('error');
                  $emailError.removeClass('hidden');
                  $emailErrorList
                    .append(myErr.text)
                    .removeClass('hidden');
                } else if (myErr.key === 'required_dependency.validate_terms.terms.dependency.email_signup') {
                  $emailError.removeClass('hidden');
                  $emailTncError
                    .append(myErr.text)
                    .removeClass('hidden');
                } else if (myErr.key === 'invalid.phone2.sms') {
                  $smsInputNode.addClass('error');
                  $smsErrorNode
                    .append(myErr.text)
                    .removeClass('hidden');
                } else if (myErr.key === 'required_dependency.phone2.sms_promotions.dependency.sms') {
                  $smsTncError
                    .append(myErr.text)
                    .addClass('error')
                    .removeClass('hidden');
                }
              }
            }
          });
        });
      });
    },

    gdprRemInfoMessageBox: function () {
      var $infoMsgGDPR = $('.info-msg-gdpr');

      if ($infoMsgGDPR.get(0)) {
        $infoMsgGDPR.remove();
      }
    },

    gdprSetInfoBoxPosition: function (infoLink, infoMessageBox, infoMsgArrow, isMobile) {
      var infoLinkTop = infoLink.offset().top + infoLink.height() + infoMsgArrow.outerHeight(true);
      var infoLinkLeft = infoLink.offset().left;
      var infoMsgMaxWidth = parseInt(infoMessageBox.css('max-width').replace('px', ''));
      var infoMsgArrowMidPoint = infoMsgArrow.outerWidth(true) / 2;

      if (isMobile || navigator.userAgent.match(/iPad/)) {
        // This is the gap between popup and page in mobile. Ideal is 10px.
        var popupLeftPosMobile = 10;

        infoMsgArrow.css({
          left: infoLinkLeft - infoMsgArrowMidPoint + 'px'
        });
        infoLinkLeft = popupLeftPosMobile;
      } else if (
        infoMessageBox.outerWidth(true) === infoMsgMaxWidth &&
        infoLinkLeft + (infoMsgMaxWidth + 25) > screen.width
      ) {
        infoLinkLeft = infoLinkLeft - infoMessageBox.innerWidth() + infoMsgArrowMidPoint;
        infoMsgArrow.addClass('top-right-arrow');
      }
      infoMessageBox.css({
        top: infoLinkTop + 'px',
        left: infoLinkLeft + 'px'
      });
    },

    gdprToolTip: function (context) {
      if (Drupal.settings.globals_variables.gdpr_compliant) {
        var isMobile = Unison.fetch.now().name === 'small';
        var infoMessageBox = $('.info-msg-gdpr');

        $('body').on('click', function (e) {
          if (
            e.target.className !== 'info-msg-gdpr' &&
            e.target.className !== 'info-msg-gdpr__txt'
          ) {
            infoMessageBox.addClass('hidden');
          }
          if ($('html').hasClass('colorbox_scroll')) {
            $('html').removeClass('colorbox_scroll');
          }
        });
        $('.info-link-gdpr', context).on('click', function (e) {
          e.preventDefault();
          var infoLink = $(e.currentTarget);
          var $welcomeOverlay = $('.welcome15-overlay');

          if ($welcomeOverlay.is(':visible')) {
            $('html').addClass('colorbox_scroll');
          }
          site.emailSignup.gdprRemInfoMessageBox();

          $(
            "<div class='info-msg-gdpr'><div class='info-msg-gdpr__arrow'></div><div class='info-msg-gdpr__txt'></div></div>"
          ).appendTo('body');
          var infoBoxEle = $('#' + infoLink.attr('message-in'));
          var infoMsgArrow = $('.info-msg-gdpr__arrow');

          $('.info-msg-gdpr__txt', '.info-msg-gdpr').html(
            "<div class='info-msg-gdpr__close'>X</div>" + infoBoxEle.html()
          );

          $('#cboxClose, .info-msg-gdpr__close', context).on('click', function (e) {
            e.stopPropagation();
            site.emailSignup.gdprRemInfoMessageBox();
            if ($welcomeOverlay.is(':visible')) {
              $('html').removeClass('colorbox_scroll');
            }
          });

          site.emailSignup.gdprSetInfoBoxPosition(infoLink, infoMessageBox, infoMsgArrow, isMobile);
          $(window).on(
            'resize-debounced',
            site.emailSignup.gdprSetInfoBoxPosition(
              infoLink,
              infoMessageBox,
              infoMsgArrow,
              isMobile
            )
          );

          $('.info-msg-gdpr__txt span').on('mousedown', function () {
            window.location = $(this).attr('data-url');
          });

          $('.js-info-msg-gdpr__popuptxt').on('mousedown', function () {
            window.open(this.href, '_blank');
          });
        });
      }
    }
  };

  Drupal.behaviors.emailSignupFormV1 = {
    attach: function (context) {
      site.emailSignup.templateContainer = $('.email-signup', context);
      site.emailSignup.initEmailSignup();
      site.emailSignup.gdprToolTip(context);
    }
  };

})(jQuery);